import React, { useContext, useEffect, useRef } from "react";
import useTranslations from "i18n/useTranslations";
import { PostRequestOTP } from "services/Api/Module/Otp";
import { PostArchievedCustomer } from "services/Api/Module/Customer";
import ModalContext from "contexts/ModalContext";
import { useLiff } from "react-liff";
import useProfileStore from "services/store/ProfileModule";
import { useNavigate } from "react-router-dom";

const MenuCustomer = ({ btnMenuRef }) => {
    const { isLoggedIn, isReady, liff } = useLiff()
    const navigate = useNavigate();
    const { lang, supportedLangs, setLang } = useTranslations(); // สำหรับเปลี่ยนภาษา
    const { t } = useTranslations();
    const { mAlert } = useContext(ModalContext);
    const btnCloseMenuRef = useRef(null);
    const menuDrawerRef = useRef(null);
    const hideAreaRef = useRef(null);
    const profile = useProfileStore();

    const handlePolicy = () =>{
        if(lang == 'th'){
            navigate('/policy-th');
        }else{
            navigate('/policy-en');
        }
    }
    const onConfrimArchieved = () => {

        mAlert.info({
            type: "confrim",
            title: `${t.menuCustomer.popup.message1} <br/>${t.menuCustomer.popup.message2}`,
            subTitle: `${t.menuCustomer.popup.message3}`,
            mode: "red",
            content: "",
            onNo: () => { },
            onYes: () => { 
                const payload = {
                    lineUid: profile?.lineUid
                };
                fetchPostArchievedCustomer(payload)
            },
        });
    }

    const fetchPostArchievedCustomer = async (payload) => {
        try {
            const response = await PostArchievedCustomer({ data: payload });
            const resData = response?.data;
            if (resData?.resultCode == "20000") {
                mAlert.info({
                    title: "แจ้งเตือน",
                    subTitle: "ยกเลิกสำเร็จ",
                    content: "",
                    onClose: () => {
                        liff.closeWindow()
                    },
                });
                
            } else {
                mAlert.info({
                    title: "แจ้งเตือน",
                    subTitle: "มีบางอย่างผิดพลาด",
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "ไม่พบข้อมูล",
                content: "",
                onClose: () => { },
            });
        }
    };
    

    useEffect(() => {
        // Set viewport dimensions
        setTimeout(() => {
            const viewheight = window.innerHeight;
            const viewwidth = window.innerWidth;
            const viewport = document.querySelector("meta[name=viewport]");
            if (viewport) {
                viewport.setAttribute("content", `height=${viewheight}px, width=${viewwidth}px, initial-scale=1.0`);
            }
        }, 300);

        // Menu Toggle
        const handleMenuToggle = () => {
            document.body.classList.toggle("openedMenu");
            if (menuDrawerRef.current) {
                menuDrawerRef.current.classList.toggle("opened");
            }
            const header = document.querySelector("header");
            if (header) {
                header.classList.toggle("opened");
            }
            if (hideAreaRef.current) {
                hideAreaRef.current.style.display = hideAreaRef.current.style.display === 'none' ? 'block' : 'none';
            }
        };

        // Event listeners
        if (btnMenuRef.current && btnCloseMenuRef.current && hideAreaRef.current) {
            btnMenuRef.current.addEventListener("click", handleMenuToggle);
            btnCloseMenuRef.current.addEventListener("click", handleMenuToggle);
            hideAreaRef.current.addEventListener("click", handleMenuToggle);
        }

        // Scroll to ID
        document.querySelectorAll('a[href*="#"]').forEach(anchor => {
            anchor.addEventListener("click", function (e) {
                const id = anchor.getAttribute("href");
                const target = document.querySelector(id);
                if (!target) return;

                e.preventDefault();
                window.scrollTo({ top: target.offsetTop, behavior: "smooth" });
            });
        });

        // Active Menu
        const url = window.location.pathname;
        const urlRegExp = new RegExp(url.replace(/\/$/, '') + "$");
        document.querySelectorAll('.bMenuPC nav a').forEach(link => {
            if (urlRegExp.test(link.href.replace(/\/$/, ''))) {
                link.classList.add('active');
            }
        });

        return () => {
            // Cleanup event listeners
            if (btnMenuRef.current) {
                btnMenuRef.current.removeEventListener("click", handleMenuToggle);
            }
            if (btnCloseMenuRef.current) {
                btnCloseMenuRef.current.removeEventListener("click", handleMenuToggle);
            }
            if (hideAreaRef.current) {
                hideAreaRef.current.removeEventListener("click", handleMenuToggle);
            }
        };
    }, []);



    return (
        <>
            <div className="bHideArea" ref={hideAreaRef} style={{ display: 'none' }}></div>
            <aside id="menuDrawer" ref={menuDrawerRef}>
                <a id="btnCloseMenu" ref={btnCloseMenuRef}></a>
                <div className="bInner">
                    <div className="bLogo">
                        <img src="assets/img/logo/logo-white.svg" alt="Logo" />
                    </div>
                    <nav>
                        <h4>{t.menuCustomer.setting}</h4>
                        {/* <h4>{t.titlePage.welcome}</h4> */}
                        <a onClick={handlePolicy}><i className="ico-policy"></i>{t.menuCustomer.policy}</a>
                        <a onClick={onConfrimArchieved}><i className="ico-cancelacc"></i>{t.menuCustomer.cancel}</a>
                        <div>
                            <p><i className="ico-lang"></i>{t.menuCustomer.lang}</p>
                            <div className="bLang">
                                <div id="switchLang">
                                    <a className={lang == 'th' ? "active" : ""} onClick={() => setLang('th')}>{t.menuCustomer.th}</a>
                                    <a className={lang == 'en' ? "active" : ""} onClick={() => setLang('en')}>{t.menuCustomer.en}</a>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </aside>
        </>
    )
}

export default MenuCustomer